

const state = {
    
    lists:{
        entities: {       
            color:'#fff',
            name:'Rezepte/Zutaten',
            sizes:'xs6 md4 lg2',
            listitem:'entitylistitem',
            tileactions: [
                {
                    name:'show',
                    icon:'visibility',
                    link:'entities_show',
                    action:''
                },
                {
                    name:'edit',
                    icon:'edit',
                    link:'entities_update',
                    action:''
                },
                {
                    name:'delete',
                    icon:'delete',
                    link:'',
                    action:''
                },        
            ]
        },
        companies:{                
            color:'#fff',
            name:'Firmen',
            sizes:'xs6 md4 lg3',
            listitem:'companylistitem',
            tileactions: [
                {
                    name:'edit',
                    icon:'edit',
                    link:'companies_update',
                    action:''
                },
                {
                    name:'delete',
                    icon:'delete',
                    link:'',
                    action:''
                },        
            ]

        },
        adresses:{                
            color:'#fff',
            name:'Adressen',
            sizes:'xs6 md4 lg3',
            listitem:'adresslistitem',
            tileactions: [
                {
                    name:'edit',
                    icon:'edit',
                    link:'adresses_update',
                    action:''
                },
                {
                    name:'delete',
                    icon:'delete',
                    link:'',
                    action:''
                },        
            ]

        },
        projects:{                
            color:'#fff',
            name:'Projekte',
            sizes:'xs6 md4 lg3',
            listitem:'projectlistitem',
            tileactions: [
                {
                    name:'edit',
                    icon:'edit',
                    link:'projects_update',
                    action:''
                },
                {
                    name:'delete',
                    icon:'delete',
                    link:'',
                    action:''
                },        
            ]

        },
    } 
    
    
    
};

export default {
  namespaced: true,
  state,
  
};